/* HanysLux theme JS — nav, cart drawer, card hover, smooth scroll.
   Cart line ops use /cart/change.js keyed by item.key (never index). Phase 4d adds optimistic
   (no-reload) rendering + AJAX add-to-cart; for now qty/remove reload to re-render from {{ cart }}. */
(function () {
  var toast = document.getElementById('toast'), tt;
  function say(m) { if (!toast) return; toast.textContent = m; toast.classList.add('show'); clearTimeout(tt); tt = setTimeout(function () { toast.classList.remove('show'); }, 2000); }

  // mobile hamburger
  var burger = document.querySelector('[data-hl-menu]'), mnav = document.getElementById('mnav');
  var mscrim = document.querySelector('[data-hl-menu-scrim]');
  if (burger && mnav) {
    function closeMenu() {
      mnav.setAttribute('hidden', '');
      if (mscrim) mscrim.setAttribute('hidden', '');
      burger.setAttribute('aria-expanded', 'false');
    }
    function openMenu() {
      mnav.removeAttribute('hidden');
      if (mscrim) mscrim.removeAttribute('hidden');
      burger.setAttribute('aria-expanded', 'true');
    }
    burger.addEventListener('click', function () {
      mnav.hasAttribute('hidden') ? openMenu() : closeMenu();
    });
    if (mscrim) mscrim.addEventListener('click', closeMenu);
    mnav.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', closeMenu); });
  }

  // product-card hover image swap
  document.querySelectorAll('.pcard__img--hover').forEach(function (hov) {
    var card = hov.closest('.pcard'); if (!card) return;
    card.addEventListener('mouseenter', function () { hov.style.opacity = 1; });
    card.addEventListener('mouseleave', function () { hov.style.opacity = 0; });
  });

  // smooth scroll for in-page anchors
  document.querySelectorAll('a[href^="#"], a[href^="/#"]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      var href = el.getAttribute('href');
      var hash = href.indexOf('#') > -1 ? '#' + href.split('#')[1] : '';
      if (hash && document.querySelector(hash)) { e.preventDefault(); document.querySelector(hash).scrollIntoView({ behavior: 'smooth' }); }
    });
  });

  /* ---- cart drawer (AJAX; add-to-cart opens the drawer, never navigates) ---- */
  var overlay = document.querySelector('[data-cd-overlay]'), drawer = document.getElementById('cartDrawer');
  /* The free-shipping threshold is NO LONGER read here. It used to be
     `parseFloat(body[data-hl-free-ship] || '35') * 100`, a bare US number compared against
     cart.total_price — which is in PRESENTMENT currency, so international shoppers were
     measured against "€35"/"¥35" against a real threshold of $50 USD. It now lives in
     window.hlFreeShip (layout/theme.liquid), resolved per country in USD and converted with
     Shopify.currency.rate. renderCart() below just re-paints the shared [data-hl-fs] blocks. */
  /* v2 config hook. The Liquid deliberately stopped emitting [data-cd-offer]: a stale cached
     copy of THIS file would otherwise keep running the pre-2026-08-19 repeating-tier arithmetic
     and repaint "10 free" at 16 units once BUY3GET5 was capped to one use. Finding nothing and
     standing down — leaving the flag-aware server render in place — is the correct degradation,
     and it is the one this guard already gives us for free. (PLAN §4 B.) */
  var offerCfg = (function () {
    var el = document.querySelector('[data-cd-offer2]');
    if (!el) return null;
    try {
      var c = JSON.parse(el.textContent);
      return (c && c.v === 2) ? c : null;      // unrecognised version -> server render stands
    } catch (e) { return null; }
  })();
  /* Eligible product ids come from the offer collection's public products.json, NOT from a
     Liquid-emitted id list: `collection.products` caps at 50 in Liquid and the eligible set
     is 159, so an emitted list would silently under-count. products.json is uncapped
     (limit max 250) and we page it. offerIds stays null until loaded — renderOffer() refuses
     to render on null rather than clobbering the CORRECT server-rendered markup with a
     bogus 0. When the ids land we re-render from the last known cart. (B-014) */
  var offerIds = null, pickIds = null, lastCart = null;
  /* Published so assets/hl-offer-modal.js can judge a checkout click without duplicating the
     ids fetch or the cart plumbing. `mutated` flips on the first client-side cart change: it's
     the signal that the server's page-load eligible-qty snapshot has gone stale, which is what
     lets the modal decide between "count exactly" and "fail open".
     `pickIds` is the SECOND scope: the discount's customerGets collection. Two lists, because
     the discount has two scopes — buys from offer-eligible, gets from discount-collection —
     and a unit in the first but not the second can pay for the offer but can never be free. */
  window.hlOffer = { cfg: offerCfg, ids: null, pickIds: null, mutated: false, refresh: null };
  /* Ids come from the collection's public products.json, NEVER from a Liquid-emitted list:
     `collection.products` caps at 50 while these sets are 188 / 124, so an emitted list would
     silently under-count. products.json is uncapped (limit max 250) and we page it. */
  function loadCollectionIds(handle, done) {
    if (!handle) return;
    var acc = [];
    function page(n) {
      return fetch('/collections/' + handle + '/products.json?limit=250&page=' + n, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (j) {
          var ps = (j && j.products) || [];
          ps.forEach(function (p) { acc.push(p.id); });
          if (ps.length === 250 && n < 4) return page(n + 1);   // guard against runaway paging
        });
    }
    page(1).then(function () {
      if (!acc.length) {
        /* Empty is NOT "still loading" — it is what products.json returns when the collection
           is unpublished from the Online Store channel, and what a non-ok response is mapped to.
           Left silent, the offer block would simply freeze at its (correct) server render for
           the rest of the session with nobody the wiser, so make it visible. */
        if (window.hlTrack) window.hlTrack('hl_offer_ids_empty', { handle: handle });
        return;                                // keep server render if the fetch came back empty
      }
      done(acc);
      if (lastCart) renderOffer(lastCart);     // catch up on any cart change that raced the fetch
    }).catch(function () {
      /* leave the list null -> renderOffer bails -> server render stands (stale but true) */
      if (window.hlTrack) window.hlTrack('hl_offer_ids_failed', { handle: handle });
    });
  }
  if (offerCfg) {
    loadCollectionIds(offerCfg.handle, function (acc) { offerIds = acc; window.hlOffer.ids = acc; });
    loadCollectionIds(offerCfg.pickshandle, function (acc) { pickIds = acc; window.hlOffer.pickIds = acc; });
  }
  function openCart() { if (!drawer) return; overlay.classList.add('open'); drawer.classList.add('open'); drawer.setAttribute('aria-hidden', 'false'); }
  function closeCart() { if (!drawer) return; overlay.classList.remove('open'); drawer.classList.remove('open'); drawer.setAttribute('aria-hidden', 'true'); }
  /* Presentment currency, not a hardcoded '$'. This printed "$44" to a shopper being billed in
     EUR/GBP/CAD/JPY — the same class of bug as the free-shipping threshold (Workstream D).
     Delegates to the single formatter in the layout bootstrap, which keeps USD byte-identical
     to the old behaviour so the primary market sees no cosmetic change. */
  function money(c) {
    if (window.hlFreeShip && window.hlFreeShip.money) return window.hlFreeShip.money(c);
    return '$' + (c / 100).toFixed(2).replace(/\.00$/, '');
  }
  function esc(s) { return (s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }

  /* Rebuilds the offer block from window.hlOfferModel — PLAN §3. This function no longer does
     any tier arithmetic of its own; that is the entire point. The same maths used to live here,
     in hl-cart-drawer.liquid, in hl-offer-modal.js and in hl-offer-upsell.liquid, and it drifted
     twice (B-014, B-017), both times printing something untrue to a shopper.

     Three ways this bails, all of them leaving the SERVER render standing rather than repainting
     from a half-known state — stale-but-true beats fresh-and-lying:
       • no model global (script order broke, or the asset 404'd)
       • no v2 config  (stale cached copy of this file against new Liquid)
       • picks count unknown (ids not loaded AND the cart already mutated)
  */
  function renderOffer(cart) {
    lastCart = cart;
    if (!drawer || !offerCfg || !offerIds) return null;
    var M = window.hlOfferModel;
    if (!M) return null;
    var offEl = drawer.querySelector('[data-cd-offer-ui]'); if (!offEl) return null;

    var bq = 0;
    cart.items.forEach(function (it) {
      if (offerIds.indexOf(it.product_id) !== -1) bq += it.quantity;
    });

    /* Units the discount can actually zero. Same three sources of trust as the eligible count:
       live cart x loaded picks ids (exact) -> the server's page-load snapshot while the cart is
       still untouched (exact) -> unknown. UNKNOWN MUST BAIL: a cart of 8 eligible rings holding
       no picks would otherwise flip an honest "0/5 free" into "5/5 free" and drop the CTA. */
    var dcq = null;
    if (pickIds) {
      dcq = 0;
      cart.items.forEach(function (it) { if (pickIds.indexOf(it.product_id) > -1) dcq += it.quantity; });
    } else if (!window.hlOffer.mutated && typeof offerCfg.dcqty === 'number') {
      dcq = offerCfg.dcqty;
    }
    if (dcq === null) return null;

    /* `cart` is a live /cart.js payload, so classify() reads what Shopify ACTUALLY granted —
       titles and zeroed units — rather than trusting the page-load snapshot in offerCfg. */
    var st = M.derive({ units: bq, picks: dcq, rollout: offerCfg.rollout, cart: cart });

    /* Copy comes from the model's COPY_HTML table so this can never disagree with the copy
       nobody approved; the Liquid mirrors the same strings. Rows the model does not own
       (1, 4-8) are the pre-existing sentences, kept here verbatim. */
    var C = M.COPY_HTML, msg;
    if (st.row === 0) msg = C.row0;
    else if (st.row === 1) msg = '<span class="cd__cliffmsg">So close! Pick your free pieces from the eligible set below to lock in the deal ✨</span>';
    else if (st.row === 2) msg = M.fill(C.row2, st);
    else if (st.row === '3a') msg = M.fill(C.row2, st) + '<p class="cd__tier2">' + M.fill(C.row3a, st) + '</p>';
    else if (st.row === '3b') msg = M.fill(C.row2, st) + '<p class="cd__tier2">' + M.fill(C.row3b, st) + '</p>';
    else if (st.row === 4) msg = '🎁 <b>Buy ' + st.next.paid + ', get ' + st.next.free + ' free</b> — add ' + st.next.paid + ' from the offer, then pick ' + st.next.free + ' on us';
    else if (st.row === 5) msg = '🎁 Add <b>' + st.paidLeft + ' more</b>, then pick <b>' + st.next.free + ' free</b>';
    else if (st.row === 6) msg = '✅ <b>You’re in — now pick your ' + st.next.free + ' free.</b> Add all ' + st.next.free + ' and they come off at checkout.';
    else if (st.row === 7) msg = '<span class="cd__cliffmsg">⚠️ <b>1 more free piece to grab.</b> That last piece is what flips them.</span>';
    else msg = '🎁 <b>' + st.slotsNeed + ' more free</b> to grab — fill all ' + st.next.free + ' and they come off at checkout';

    var ch = offerCfg.cheap || {}, stt = offerCfg.starter || {}, extra = '', prog = '';

    /* Everything below row 0 is a claim of some kind — a meter, a CTA, a one-tap completer — so
       none of it renders when the offer state is untrusted or the feature is off. */
    if (st.row !== 0) {
      /* st.gateMet, NOT a local re-derivation. This read `pipFilled === pipTotal || paidLeft === 0`,
         which agreed with the model only while a confirmed rung pinned the track full. Now that the
         track widens to the next rung (5/8), that test goes false at exactly the confirmed state it
         was meant to cover — 5 !== 8, paidLeft 2 — and the dots would silently vanish into the thin
         progress bar. One definition, in the model, mirrored by the Liquid's `gate_met`. */
      if (st.gateMet) {
        for (var pi = 0; pi < st.pipTotal; pi++) prog += '<span class="cd__pip' + (pi < st.pipFilled ? ' on' : '') + '"></span>';
        prog = '<div class="cd__pips" role="img" aria-label="' + st.pipFilled + ' of ' + st.pipTotal +
               ' free pieces in your cart">' + prog + '<span class="cd__pipcount"><b>' +
               st.pipFilled + '</b>/' + st.pipTotal + ' free</span></div>';
      } else {
        var pct = st.next && st.next.paid ? Math.min(100, Math.round(st.paysFor / st.next.paid * 100)) : 0;
        prog = '<div class="cd__bar"><span style="width:' + pct + '%"></span></div>';
      }
      if (st.cliffish && ch.id) {
        extra += '<button class="cd__cliffadd" type="button" data-hl-cliff-add data-variant-id="' + ch.id + '">'
              + 'Add 1 more — ' + esc(ch.title) + ' (' + money(ch.price) + ', free at ' + st.next.goal + ')</button>';
      }
      /* Destination AND label both come from the model, never assembled here. This block used to
         hardcode the picks collection and print `slotsNeed` as a free-piece count, which produced
         two live defects: at 0 units it rendered "Pick my 8 free" directly beneath "get 5 free",
         and at 8-12 units it sent her to the free shelf saying "Pick my free pieces" while the
         checkout modal sent her to Belly Bars — same cart, opposite instructions. */
      if (st.ctaKind && !st.cliffish) {
        extra += '<a class="cd__pickfree" href="' + esc(st.ctaHref)
              + '" data-hl-pick-free>' + esc(st.ctaLabel) + '</a>';
      }
      if (stt.ok && bq === 0 && st.next) {
        extra += '<button class="cd__starter" type="button" data-hl-starter-add data-variant-ids="' + stt.ids + '">'
              + 'Add the ' + st.next.goal + '-Ring Starter Set — ' + money(stt.pay)
              + '<span>' + st.next.free + ' of them free · save ' + money(stt.save) + '</span></button>';
      }
    }

    offEl.innerHTML = '<p>' + msg + '</p>' + prog + extra;

    /* Free-picks disclaimer. Shown when she has the RINGS but the discount has not actually
       landed — the cart that reaches checkout expecting money off and gets none. Lives in
       .cd__foot, outside this innerHTML, so re-renders never destroy it. */
    var ff = drawer.querySelector('[data-cd-freefrom]');
    if (ff) {
      var showFF = st.rollout !== 'off' && bq >= M.RUNG1.goal && !st.confirmed;
      showFF ? ff.removeAttribute('hidden') : ff.setAttribute('hidden', '');
    }

    /* PLAN §8 telemetry: an under/over-grant surfaces as allocState 'mismatch' in the existing
       stream rather than needing an order-alerting pipeline. */
    if (window.hlTrack && (st.allocState === 'mismatch' || st.allocState === 'other')) {
      window.hlTrack('hl_offer_alloc_' + st.allocState, {
        units: bq, picks: dcq, server_free: st.serverFree,
        applied_title: st.appliedTitle, rollout: st.rollout
      });
    }
    return st;
  }

  function renderCart(cart) {
    if (!drawer) return;
    var countEl = document.querySelector('.cart-count'); if (countEl) countEl.textContent = cart.item_count;
    var sub = drawer.querySelector('[data-subtotal]'); if (sub) sub.textContent = money(cart.total_price);
    /* DOCUMENT-scoped, not drawer-scoped: /cart also renders a [data-hl-fs] meter, and both
       must track the same cart. The threshold, the currency conversion and the copy all live in
       window.hlFreeShip so the server render and this re-render cannot disagree. If the
       bootstrap is missing, the server-rendered block is left exactly as it is rather than
       being overwritten with a guess. */
    if (window.hlFreeShip && window.hlFreeShip.paintAll) window.hlFreeShip.paintAll(cart.total_price);
    var off = renderOffer(cart);
    var items = drawer.querySelector('[data-cd-items]'), empty = drawer.querySelector('[data-cd-empty]');
    if (items) {
      items.innerHTML = '';
      cart.items.forEach(function (it) {
        var row = document.createElement('div'); row.className = 'cd__line'; row.setAttribute('data-cart-line', it.key);
        var vt = (it.variant_title && it.variant_title.indexOf('Default') === -1) ? '<div class="cd__lvar">' + esc(it.variant_title) + '</div>' : '';
        row.innerHTML = '<img src="' + (it.image || '') + '" alt="" width="64" height="64"><div><div class="cd__ltitle">' + esc(it.product_title) + '</div>' + vt +
          '<div class="cd__qty"><button type="button" data-dec aria-label="Decrease">–</button><span data-qty>' + it.quantity + '</span><button type="button" data-inc aria-label="Increase">+</button></div></div>' +
          '<div class="cd__lright"><div class="cd__lprice">' + money(it.final_line_price) + '</div><button type="button" class="cd__rm" data-rm>Remove</button></div>';
        items.appendChild(row);
      });
    }
    if (empty) { cart.item_count > 0 ? empty.setAttribute('hidden', '') : empty.removeAttribute('hidden'); }
    /* Upsell mirrors the Liquid: hidden at a completed tier, because the shopper has already
       earned the free rings and the next 1..goal-1 units are charged FULL price — "get 5 free"
       there would be a lie. `off` is null when offerIds hasn't loaded; then fall back to the
       plain empty-cart rule rather than guessing at the tier. */
    /* DOCUMENT-scoped, not drawer-scoped: the same rail is also rendered on the PDP under the
       ATC (snippets/hl-offer-upsell.liquid). Both must react to cart changes identically.
       Hidden at a completed tier — the shopper already earned the free rings and the next
       1..goal-1 units are full price, so "get 5 free" would be a lie. The PDP copy stays
       visible on an empty cart (that's when it's most useful); the drawer's doesn't. */
    document.querySelectorAll('[data-cd-upsell]').forEach(function (ups) {
      var isPdp = ups.getAttribute('data-cd-upsell-context') === 'pdp';
      /* Hidden when there is no rung left to climb (the ladder is FLAT above 13 — "get N free"
         there would be a lie), when the offer state is untrusted or off (row 0), and, in the
         drawer only, on an empty cart. The PDP rail stays up on an empty cart: that is exactly
         when a shopper on a product page needs the nudge. */
      var hide = (off && (!off.next || off.row === 0)) || (!isPdp && cart.item_count === 0);
      hide ? ups.setAttribute('hidden', '') : ups.removeAttribute('hidden');
      var eyebrow = ups.querySelector('.eyebrow');
      /* Paid-gate framing, same as the drawer — the rail must never print off.remain. */
      /* slotsNeed, not a units-only count — must match snippets/hl-offer-upsell.liquid's
         u_slots_need and the drawer's number, or the PDP rail and the drawer print different
         answers on the same page (it told a 7-ring / 0-pick cart "1 free piece left to grab",
         one tap from $0.00 off). */
      /* Same numbers as the drawer, from the same derivation — the rail once told a 7-ring /
         0-pick cart "1 free piece left to grab" while the drawer said something else entirely.
         `off.next` is guaranteed non-null here because a null one is hidden above. */
      if (eyebrow && off && off.next) {
        eyebrow.textContent = off.units === 0
          ? 'Add ' + off.next.paid + ', then pick ' + off.next.free + ' free'
          : off.paidLeft > 0
            ? 'Add ' + off.paidLeft + ' more, then pick ' + off.next.free + ' free'
            : off.slotsNeed + ' free ' + (off.slotsNeed === 1 ? 'piece' : 'pieces') + ' left to grab';
      }
    });
    var inCart = {}; cart.items.forEach(function (it) { inCart[it.product_id] = 1; });
    document.querySelectorAll('[data-uprow-product]').forEach(function (row) {
      row.style.display = inCart[row.getAttribute('data-uprow-product')] ? 'none' : '';
    });
    /* One broadcast per cart change. assets/hl-offer-modal.js listens so the intercept modal
       stays in step with the drawer without either file reaching into the other's internals. */
    document.dispatchEvent(new CustomEvent('hl:cart:updated', { detail: cart }));
  }
  function refresh(openAfter) {
    window.hlOffer.mutated = true;
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (c) { renderCart(c); if (openAfter) openCart(); });
  }
  window.hlOffer.refresh = refresh;
  /* B-016 (2026-08-18, operator: "the little quantity selector in the cart doesn't work").
     ROOT CAUSE IS TWO THINGS, and only the second one is ours.

     1. DATA. /cart/change.js legitimately 422s on most of this catalogue. Admin API over 494
        tracked/DENY variants on ACTIVE products: 47.2% are stocked at exactly 1 and 15.2% are
        already at <=0, so 62.3% CANNOT go past qty 1. Shopify answers the "+" with
        {"status":422,"description":"Only 1 item was added to your cart due to availability."}
        That refusal is correct and no theme change can make the unit appear.

     2. THEME. This function never checked r.ok, so that 422 ERROR OBJECT was handed to
        renderCart() as though it were a cart. Measured live on hanyslux.com before the fix
        (one tap of "+" on a stock-1 line): the drawer subtotal painted "$NaN", the header cart
        badge blanked, `lastCart` was poisoned with the error object, and renderOffer() then
        threw on cart.items.forEach — swallowed by the bare catch below, so the shopper's only
        signal was a toast reading "Could not update cart". A correct server refusal was being
        rendered as a broken cart. THAT is what "doesn't work" meant.

     So: never paint a non-ok body, say WHY in the brand's voice, and re-sync from server truth
     so a refused mutation can never strand a half-painted drawer. Same contract as
     close_enemies' mutate() — read the comment there before changing this shape.

     `increasing` is passed by the caller because only a "+" can be refused for stock; a
     decrease or a remove that fails is a real fault and must not blame inventory. */
  var MSG_NO_STOCK = 'That’s the last one! Can’t add more of this piece rn 💕';
  var MSG_CART_FAIL = 'Glitch! Try that again? 🛠️';
  function changeLine(key, qty, increasing) {
    window.hlOffer.mutated = true;
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) {
            var err = new Error(data.description || data.message || 'Cart error');
            err.status = r.status;
            throw err;
          }
          return data;
        });
      })
      .then(function (c) { renderCart(c); })
      .catch(function (e) {
        /* Shopify's own words go to the console, never to the shopper: its stock message says
           "added" during a quantity CHANGE, which reads as a bug to her and as noise to us. */
        if (window.console && window.console.warn) {
          window.console.warn('[hl] cart/change.js', (e && e.status) || '', (e && e.message) || e);
        }
        say(e && e.status === 422 && increasing ? MSG_NO_STOCK : MSG_CART_FAIL);
        /* Re-sync unconditionally. The failed paint above may have already written NaN/blank
           into shared nodes, and only the server can say what the cart really holds. */
        return refresh(false).catch(function () { });
      });
  }
  function addToCart(form) {
    var fd = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
      .then(function (r) { if (!r.ok) return r.json().then(function (e) { throw e; }); return r.json(); })
      .then(function () { refresh(true); })
      .catch(function (e) { say((e && e.description) || 'Could not add to cart'); });
  }

  var cartBtn = document.querySelector('[data-hl-cart]');
  if (cartBtn) cartBtn.addEventListener('click', function (e) { e.preventDefault(); openCart(); });
  if (overlay) overlay.addEventListener('click', closeCart);
  document.querySelectorAll('[data-cd-close]').forEach(function (x) { x.addEventListener('click', closeCart); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });
  if (drawer) {
    drawer.addEventListener('click', function (e) {
      var line = e.target.closest('.cd__line'); if (!line) return;
      var key = line.getAttribute('data-cart-line');
      var qEl = line.querySelector('[data-qty]'); var cur = qEl ? parseInt(qEl.textContent, 10) : 1;
      if (e.target.closest('[data-inc]')) changeLine(key, cur + 1, true);
      else if (e.target.closest('[data-dec]')) changeLine(key, Math.max(0, cur - 1), false);
      else if (e.target.closest('[data-rm]')) changeLine(key, 0, false);
    });
  }
  // intercept ALL add-to-cart forms -> AJAX add + open drawer (never navigate to /cart)
  document.querySelectorAll('form[action*="/cart/add"]').forEach(function (f) {
    f.addEventListener('submit', function (e) { e.preventDefault(); addToCart(f); });
  });
  // cart-drawer upsell "Add" buttons -> AJAX add by variant id + refresh drawer in place
  document.querySelectorAll('[data-hl-upsell-add]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = btn.getAttribute('data-variant-id'); if (!id) return;
      btn.disabled = true; btn.textContent = 'Adding…';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: id, quantity: 1 }) })
        .then(function (r) { return r.json(); }).then(function () { refresh(true); })
        .catch(function () { say('Could not add'); })
        .then(function () { btn.disabled = false; btn.textContent = 'Add'; });
    });
  });

  // Starter Set (one tap = 8 rings) + cliff-guard (the 8th ring at qty 7).
  // DELEGATED on document because renderCart() replaces the offer UI's innerHTML on every
  // cart change — directly-bound listeners would be destroyed on the first update. (B-014)
  function addItems(btn, body, failMsg) {
    btn.disabled = true; var label = btn.innerHTML; btn.textContent = 'Adding…';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) return r.json().then(function (x) { throw x; }); return r.json(); })
      .then(function () { refresh(true); })   // re-render replaces the button, so no label restore needed
      .catch(function (x) { say((x && x.description) || failMsg); btn.disabled = false; btn.innerHTML = label; });
  }
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var st = e.target.closest('[data-hl-starter-add]');
    if (st) {
      var ids = (st.getAttribute('data-variant-ids') || '').split(',')
        .map(function (s) { return s.trim(); }).filter(Boolean);
      if (!ids.length) return;
      addItems(st, { items: ids.map(function (id) { return { id: id, quantity: 1 }; }) }, 'Could not add the set');
      return;
    }
    var cl = e.target.closest('[data-hl-cliff-add]');
    if (cl) {
      var id = cl.getAttribute('data-variant-id');
      if (id) addItems(cl, { id: id, quantity: 1 }, 'Could not add');
      return;
    }
    /* QUICK ADD from a product card. Delegated for the same reason as everything else in this
       listener: collection grids, search results and the best-seller rails are re-rendered, and a
       directly-bound listener dies with the node it was bound to (B-014).

       Only ever present on SINGLE-VARIANT, in-stock products — hl-product-card.liquid renders a
       plain link to the PDP when there is a choice to make, because bar length and gauge are
       different physical dimensions and guessing them ships jewellery that does not fit. */
    var qa = e.target.closest('[data-hl-quick-add]');
    if (qa) {
      e.preventDefault();
      var qid = qa.getAttribute('data-variant-id');
      if (!qid || qa.disabled) return;
      var qLabel = qa.innerHTML;
      qa.disabled = true; qa.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: qid, quantity: 1 })
      })
        .then(function (r) { if (!r.ok) return r.json().then(function (x) { throw x; }); return r.json(); })
        /* refresh(true) opens the drawer, which is the point: she sees the offer meter move and
           the next instruction ("Add 2 more, then pick 5 free") in the same beat as the add. */
        .then(function () { refresh(true); })
        /* 422 here is the real "only 1 left" case, and `description` carries Shopify's own
           sentence — say that rather than a generic failure. */
        .catch(function (x) { say((x && x.description) || 'Could not add'); })
        /* Unlike the drawer buttons above, this card sits OUTSIDE the drawer and nothing
           re-renders it, so the label has to be put back by hand or it reads "Adding…" forever. */
        .then(function () { qa.disabled = false; qa.innerHTML = qLabel; });
      return;
    }
    /* NOTE: [data-hl-pick-free] is deliberately NOT handled here. Operator 2026-08-18: the
       drawer CTA navigates to the picks collection rather than opening the in-place picker.
       It is a plain <a href="/collections/{picks}"> and the browser does the work — do not
       reintroduce a click handler that preventDefault()s it. The checkout-intercept modal is
       untouched and still fires on its own path. */
  });

  // shop-by-category carousel arrow
  document.querySelectorAll('[data-catrow-next]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var wrap = btn.closest('.catrow__wrap');
      var scroller = wrap && wrap.querySelector('[data-catrow]');
      if (scroller) scroller.scrollBy({ left: Math.min(640, scroller.clientWidth * 0.8), behavior: 'smooth' });
    });
  });

  // collection sort — auto-submit the GET form on change (falls back to native form submit if JS off)
  var sortForm = document.querySelector('[data-sort-form]');
  if (sortForm) {
    var sortSel = sortForm.querySelector('[data-sort-select]');
    if (sortSel) sortSel.addEventListener('change', function () { sortForm.submit(); });
  }
  // collection filter dropdowns (product type, etc.) — navigate to the selected option's URL
  document.querySelectorAll('[data-nav-select]').forEach(function (sel) {
    sel.addEventListener('change', function () { if (this.value) window.location.href = this.value; });
  });

  // scroll-progress bar (works on mobile + desktop; hidden when nothing to scroll)
  document.querySelectorAll('[data-catrow]').forEach(function (scroller) {
    var wrap = scroller.closest('.catrow__wrap');
    var bar = wrap && wrap.querySelector('[data-catrow-bar]');
    var thumb = wrap && wrap.querySelector('[data-catrow-thumb]');
    if (!bar || !thumb) return;
    function update() {
      var sw = scroller.scrollWidth, cw = scroller.clientWidth;
      if (sw <= cw + 4) { bar.setAttribute('hidden', ''); return; }
      bar.removeAttribute('hidden');
      thumb.style.width = (cw / sw * 100) + '%';
      thumb.style.left = (scroller.scrollLeft / sw * 100) + '%';
    }
    scroller.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });
})();
